import { render, staticRenderFns } from "./ChooseImage.vue?vue&type=template&id=b22a95f6"
import script from "./ChooseImage.vue?vue&type=script&lang=js"
export * from "./ChooseImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports